export const DESKTOP_SIDEBAR_TOGGLE_EVENT = 'zb:desktop-sidebar-toggle';

export const toggleDesktopSidebar = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(DESKTOP_SIDEBAR_TOGGLE_EVENT));
};
